import SpaceForButton from '@/components/_common/SpaceForButtons';
import { Button, Typography } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';

interface Props {
  generateInvoiceId: number;
  setGenerateInvoiceId: React.Dispatch<React.SetStateAction<number>>;
}

const GenerateInvoiceButtons: React.FC<Props> = ({
  generateInvoiceId,
  setGenerateInvoiceId,
}) => {
  const history = useHistory();

  return (
    <>
      <Typography.Title level={5}>
        Nota fiscal gerada com sucesso!
      </Typography.Title>

      <SpaceForButton justifyContent="center">
        <Button type="primary" block onClick={() => setGenerateInvoiceId(0)}>
          Continuar na devolução
        </Button>

        <Button
          type="primary"
          block
          onClick={() =>
            history.push(`/app/fiscal/invoice/NFE/${generateInvoiceId}/datas`)
          }
        >
          Ir para a nota gerada
        </Button>
      </SpaceForButton>
    </>
  );
};

export default GenerateInvoiceButtons;
